import type { ReactElement } from 'react';
import type { StatusEvidence } from '@/hooks/useStatusEvidence';
import { statusEvidenceDisplay } from '@/lib/statusEvidence';
import {
  STATUS_CONFIG,
  EXTRA_BADGE_CLASS,
  normalizeStatus,
  type CanonicalStatus,
} from '@/constants/status';

export interface StatusBadgeProps {
  readonly evidence?: StatusEvidence;
  readonly status: string | null | undefined;
}

export function StatusBadge({ status, evidence }: StatusBadgeProps): ReactElement {
  if (evidence) {
    const display = statusEvidenceDisplay(evidence);
    return <span className={`badge ${display.badgeClass}`}>{display.label}</span>;
  }
  const normalized = normalizeStatus(status);
  const cfg = STATUS_CONFIG[normalized as CanonicalStatus];
  if (cfg) {
    const prefix = normalized === 'Complete' ? '✓ ' : '';
    return <span className={`badge ${cfg.badgeClass}`}>{`${prefix}${cfg.label}`}</span>;
  }
  const raw = status ?? 'Draft';
  const cls = EXTRA_BADGE_CLASS[raw] ?? 'badge-draft';
  return <span className={`badge ${cls}`}>{raw}</span>;
}
